import React from 'react';
import { useStudioTypeSize } from '../StudioTypeScale';
import type { StudioPageContent } from '../../../constants';
import LayoutFrame, { type LayoutContentProps } from './LayoutFrame';

interface TitleBulletsContentProps extends Partial<LayoutContentProps> {
  content: StudioPageContent;
  format: string;
}

const TitleBulletsContent: React.FC<TitleBulletsContentProps> = ({ content, format, tokens }) => {
  const isStory = format === 'story';
  const t = tokens!;
  const typeSize = useStudioTypeSize();
  const bullets = Array.isArray(content.bullets) ? content.bullets : [];

  return (
    <div>
      <div
        style={{
          maxWidth: 306,
          color: t.ink,
          fontSize: typeSize(isStory ? 28 : 23),
          fontWeight: 700,
          letterSpacing: '-0.8px',
          lineHeight: 1.18
        }}
      >
        {content.title}
      </div>
      {content.subtitle && (
        <div
          style={{
            maxWidth: 300,
            marginTop: isStory ? 12 : 9,
            color: t.muted,
            fontSize: typeSize(isStory ? 13 : 11.5),
            fontWeight: 500,
            lineHeight: 1.5
          }}
        >
          {content.subtitle}
        </div>
      )}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: isStory ? 12 : 9,
          marginTop: isStory ? 26 : 18
        }}
      >
        {bullets.map((bullet, index) => (
          <div
            key={`${index}-${bullet}`}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 13,
              padding: isStory ? '14px 15px' : '11px 13px',
              border: `1px solid ${t.hairline}`,
              borderRadius: t.radius.lg,
              background: t.cardBg,
              boxShadow: t.shadow
            }}
          >
            <div
              style={{
                minWidth: isStory ? 34 : 30,
                height: isStory ? 34 : 30,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                borderRadius: t.radius.md,
                color: t.onAccent,
                background: t.accent,
                fontSize: typeSize(isStory ? 14 : 12.5),
                fontWeight: 700
              }}
            >
              {index + 1}
            </div>
            <div style={{ color: t.ink, fontSize: typeSize(isStory ? 13 : 11.5), fontWeight: 600, lineHeight: 1.42 }}>
              {bullet}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

interface TitleBulletsLayoutProps {
  width: number;
  height: number;
  format: string;
  content?: StudioPageContent;
  themeColor?: string;
  profileName?: string;
}

const TitleBulletsLayout: React.FC<TitleBulletsLayoutProps> = props => (
  <LayoutFrame {...props}>
    <TitleBulletsContent content={props.content || {}} format={props.format} />
  </LayoutFrame>
);

export default TitleBulletsLayout;
